const css = `._7pr_8a__definition{width:500px;position:relative}._7pr_8a__definitionTooltip{width:380px;position:relative}._7pr_8a__staticHeight{height:400px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"definitionTooltip":"_7pr_8a__definitionTooltip","definition":"_7pr_8a__definition","staticHeight":"_7pr_8a__staticHeight"};
